import { render, staticRenderFns } from "./UlasPesananPengiriman.vue?vue&type=template&id=58f15cc1&scoped=true&"
import script from "./UlasPesananPengiriman.vue?vue&type=script&lang=js&"
export * from "./UlasPesananPengiriman.vue?vue&type=script&lang=js&"
import style0 from "./UlasPesananPengiriman.vue?vue&type=style&index=0&id=58f15cc1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58f15cc1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!D:/Project/Gitpanda/Agroforestcape/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib'
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardActions } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VContent } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VApp,VBtn,VCard,VCardActions,VCardText,VContainer,VContent,VFlex,VLayout})
